import { render, staticRenderFns } from "./basecarteradetalladacompleta.vue?vue&type=template&id=a4b7e8c6"
import script from "./basecarteradetalladacompleta.vue?vue&type=script&lang=js"
export * from "./basecarteradetalladacompleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports